<template>
  <section id="login">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <form>
            <div class="form-group">
              <label>Kyçu në Marimanga</label>
              <input
                type="email"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="email e perdoruesit"
                :value="email"
                @input="getEmail"
              >
              <input
                type="password"
                placeholder="fjalekalimi"
                :value="password"
                @input="getPassword"
                v-on:keyup.enter="requestLogin"
              >
            </div>

            <div class="form-group" style="padding-bottom: 10px">
              <button type="submit" @click="requestLogin">kycu</button>
            </div>
            <p v-if="loginError === 1" style="color: red">Kredencialet e dhena nuk jane te sakta.</p>
            <p v-if="loginError === 2" style="color: red">Llogaria juaj nuk eshte aktivizuar ende.</p>
            <router-link tag="a" to="forgotpassword">Kam harruar fjalekalimin</router-link>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<style>
html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "login",
  methods: {
    getEmail(e) {
      this.$store.dispatch("login/getEmail", e.target.value);
    },
    getPassword(e) {
      this.$store.dispatch("login/getPassword", e.target.value);
    },
    requestLogin(e) {
      e.preventDefault();
      this.$store.dispatch("login/requestLogin");
    }
  },
  computed: {
    ...mapGetters({
      email: "login/email",
      password: "login/password",
      loginError: "login/loginError"
    })
  }
};
</script>
